(function () {
  'use strict';
  var d = document, w = window;
  function all(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function safe(fn) { try { fn(); } catch (e) {  } }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function txt(root, key, fallback) { var v = root.getAttribute('data-t-' + key); return v || fallback; }
  function on(bag, el, type, fn, opt) {
    el.addEventListener(type, fn, opt || false);
    bag.push(function () { el.removeEventListener(type, fn, opt || false); });
  }
  var mqReduce = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function onReduceChange(bag, fn) {
    if (!mqReduce) { return; }
    if (mqReduce.addEventListener) { mqReduce.addEventListener('change', fn); bag.push(function () { mqReduce.removeEventListener('change', fn); }); }
    else if (mqReduce.addListener) { mqReduce.addListener(fn); bag.push(function () { mqReduce.removeListener(fn); }); }
  }
  function play(v) { try { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {} }
  function focusHeading(el) {
    var h = /^H[1-4]$/.test(el.tagName) ? el : null;
    if (!h) {
      var hs = el.querySelectorAll('h1, h2, h3');
      for (var i = 0; i < hs.length; i++) { if (hs[i].getClientRects().length) { h = hs[i]; break; } }
    }
    if (!h) { return; }
    if (!h.hasAttribute('tabindex')) { h.setAttribute('tabindex', '-1'); }
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
  }
  function header(root, bag) {
    var nav = d.getElementById('nav');
    if (!nav) { return; }
    var last = -1, queued = false;
    function measure() {
      queued = false;
      var pos = w.getComputedStyle(nav).position;
      if (pos !== 'fixed' && pos !== 'sticky') { if (last !== -1) { root.style.removeProperty('--htu-nav'); last = -1; } return; }
      var b = Math.round(nav.getBoundingClientRect().bottom);
      if (b > 0 && b !== last) { last = b; root.style.setProperty('--htu-nav', b + 'px'); }
    }
    function schedule() {
      if (queued) { return; }
      queued = true;
      (w.requestAnimationFrame || w.setTimeout)(function () { safe(measure); });
    }
    on(bag, w, 'scroll', schedule, { passive: true });
    on(bag, w, 'resize', schedule);
    on(bag, nav, 'transitionend', schedule);   
    measure();
  }
  function nav(root, bag) {
    var toc = root.querySelector('.htu-toc');
    var bar = root.querySelector('[data-htu-bar]');
    var btn = bar ? bar.querySelector('.htu-bar-btn') : null;
    var panel = bar ? bar.querySelector('.htu-bar-panel') : null;
    var links = all('.htu-toc a[href^="#"], .htu-bar-panel a[href^="#"]', root);
    var ids = [];
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (id && ids.indexOf(id) < 0 && d.getElementById(id)) { ids.push(id); }
    });
    var current = null;
    function chapterOf(id) {
      if (id === 'which-kit') { return -1; }
      var host = closest(d.getElementById(id), '[data-chapter]');
      var n = host ? parseInt(host.getAttribute('data-chapter'), 10) : -1;
      return isNaN(n) ? -1 : n;
    }
    function titleOf(id) {
      var a = (toc || root).querySelector('a[href="#' + id + '"]');
      return a ? a.textContent.replace(/^\s*↑\s*/, '').replace(/\s+/g, ' ').trim() : '';
    }
    function label(id) {
      var ch = id ? chapterOf(id) : -1, t = id ? titleOf(id) : '', sep = t ? ' · ' + t : '';
      if (ch === 0) { return [txt(root, 'before', 'Before you start') + sep, 0]; }
      if (ch >= 1 && ch <= 5) { return [txt(root, 'step', 'Step [n] of 5').replace('[n]', String(ch)) + sep, ch / 5]; }
      if (ch === 6) { return [txt(root, 'next', 'Next time') + sep, 1]; }
      return [txt(root, 'jump', 'Jump to a step'), 0];
    }
    function paint() {
      links.forEach(function (a) {
        if (current && a.getAttribute('href') === '#' + current) { a.setAttribute('aria-current', 'location'); }
        else { a.removeAttribute('aria-current'); }
      });
      var l = label(current);
      all('[data-htu-label]', root).forEach(function (el) { if (el.textContent !== l[0]) { el.textContent = l[0]; } });
      all('[data-htu-fill]', root).forEach(function (el) { el.style.width = Math.round(l[1] * 100) + '%'; });
      all('.htu-toc-progress', root).forEach(function (el) { el.classList.toggle('htu-idle', !current || chapterOf(current) === -1); });
      if (toc && toc.scrollHeight > toc.clientHeight + 4) {
        var cur = toc.querySelector('a[aria-current]');
        if (cur) {
          var r = cur.getBoundingClientRect(), tr = toc.getBoundingClientRect();
          if (r.top < tr.top + 48 || r.bottom > tr.bottom - 32) { toc.scrollTop += (r.top - tr.top) - toc.clientHeight / 3; }
        }
      }
    }
    function compute() {
      var line = w.innerHeight * 0.4, best = null, bestTop = -Infinity;
      for (var i = 0; i < ids.length; i++) {
        var el = d.getElementById(ids[i]);
        if (!el || !el.getClientRects().length) { continue; }
        var top = el.getBoundingClientRect().top;
        if (top <= line && top >= bestTop) { best = ids[i]; bestTop = top; }
      }
      current = best;
      paint();
    }
    var queued = false;
    function schedule() {
      if (queued) { return; }
      queued = true;
      (w.requestAnimationFrame || w.setTimeout)(function () { queued = false; safe(compute); });
    }
    on(bag, w, 'scroll', schedule, { passive: true });
    on(bag, w, 'resize', schedule);
    on(bag, w, 'hashchange', schedule);
    on(bag, w, 'load', schedule);
    compute();
    function setOpen(open) {
      if (!btn || !panel) { return; }
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        var c = panel.querySelector('a[aria-current]');
        if (c) { panel.scrollTop = Math.max(0, c.offsetTop - panel.clientHeight / 3); }
      }
    }
    if (btn && panel) {
      setOpen(false);
      on(bag, btn, 'click', function () { setOpen(panel.hidden); });
      on(bag, d, 'keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && !panel.hidden) { setOpen(false); btn.focus(); }
      });
      on(bag, d, 'click', function (e) { if (!panel.hidden && !bar.contains(e.target)) { setOpen(false); } });
    }
    on(bag, root, 'click', function (e) {
      var a = closest(e.target, 'a[href^="#"]');
      if (!a || !((toc && toc.contains(a)) || (panel && panel.contains(a)))) { return; }
      var el = d.getElementById(a.getAttribute('href').slice(1));
      if (!el) { return; }
      if (panel && panel.contains(a)) { setOpen(false); }
      w.setTimeout(function () { focusHeading(el); }, 0);
    });
  }
  function anims(root, bag) {
    var figs = all('figure.htu-anim', root);
    if (!figs.length) { return; }
    var P = txt(root, 'pause-anim', 'Pause the animation'), Q = txt(root, 'play-anim', 'Play the animation');
    function setPaused(f, paused) {
      f.classList.toggle('htu-is-paused', paused);
      var b = f.querySelector('.htu-anim-pause');
      if (b) { b.removeAttribute('aria-pressed'); b.setAttribute('aria-label', paused ? Q : P); }
    }
    figs.forEach(function (f) {
      setPaused(f, false);
      var b = f.querySelector('.htu-anim-pause');
      if (b) { on(bag, b, 'click', function () { setPaused(f, !f.classList.contains('htu-is-paused')); }); }
    });
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('htu-is-offscreen', !(en.isIntersecting && en.intersectionRatio >= 0.3)); });
      }, { threshold: [0, 0.3, 0.6, 1] });
      figs.forEach(function (f) { io.observe(f); });
      bag.push(function () { io.disconnect(); });
    }
  }
  function loops(root, bag) {
    var frames = all('[data-htu-loop]', root);
    if (!frames.length) { return; }
    var P = txt(root, 'pause-video', 'Pause the video'), Q = txt(root, 'play-video', 'Play the video');
    var items = [];
    frames.forEach(function (fr) {
      var v = fr.querySelector('video'), b = fr.querySelector('.htu-vpause');
      if (!v) { return; }
      v.muted = true; v.loop = true; v.playsInline = true;
      v.removeAttribute('autoplay');
      var it = { fr: fr, v: v, b: b, user: reduced(), seen: false };
      function sync() {
        fr.classList.toggle('htu-is-paused', v.paused);
        if (b) { b.setAttribute('aria-label', v.paused ? Q : P); }
      }
      it.go = function () { if (it.seen && !it.user) { play(v); } else if (!v.paused) { v.pause(); } };
      if (b) {
        on(bag, b, 'click', function () {
          if (v.paused) { it.user = false; play(v); } else { it.user = true; v.pause(); }
        });
      }
      on(bag, v, 'play', sync);
      on(bag, v, 'pause', sync);
      sync();
      items.push(it);
    });
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].fr === en.target) { items[i].seen = en.isIntersecting && en.intersectionRatio >= 0.35; items[i].go(); }
          }
        });
      }, { threshold: [0, 0.35, 0.7] });
      items.forEach(function (it) { io.observe(it.fr); });
      bag.push(function () { io.disconnect(); });
    }
    onReduceChange(bag, function () {
      if (reduced()) { items.forEach(function (it) { it.user = true; it.go(); }); }
    });
  }
  function printing(root, bag) {
    var opened = [];
    on(bag, w, 'beforeprint', function () {
      opened = all('details:not([open])', root);
      opened.forEach(function (x) { x.setAttribute('open', ''); });
    });
    on(bag, w, 'afterprint', function () { opened.forEach(function (x) { x.removeAttribute('open'); }); opened = []; });
  }
  function init(root) {
    if (!root || root.__htuBag) { return; }
    var bag = root.__htuBag = [];
    root.classList.add('htu-js');
    safe(function () { header(root, bag); });
    safe(function () { nav(root, bag); });
    safe(function () { anims(root, bag); });
    safe(function () { loops(root, bag); });
    safe(function () { printing(root, bag); });
  }
  function destroy(root) {
    if (!root || !root.__htuBag) { return; }
    root.__htuBag.forEach(function (f) { safe(f); });
    root.__htuBag = null;
  }
  function boot() { all('[data-htu]').forEach(function (r) { safe(function () { init(r); }); }); }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  d.addEventListener('shopify:section:load', function (e) { all('[data-htu]', e.target).forEach(function (r) { safe(function () { init(r); }); }); });
  d.addEventListener('shopify:section:unload', function (e) { all('[data-htu]', e.target).forEach(function (r) { safe(function () { destroy(r); }); }); });
})();
